/**
 * monetization/query-keys — TanStack Query key factory for the kit.
 * Same contract as `utils/query-keys.ts`: never inline arrays at the call site.
 /** Waits for the app to finish booting (skeleton overlay disappears). */

export const billingQueryKeys = {
  all: ["billing"] as const,
  config: () => ["billing", "config"] as const,
  usage: () => ["billing", "usage"] as const,
  adminConfig: () => ["admin", "monetization"] as const,
};
